import { render, staticRenderFns } from "./TableCustomerUseCoupon.vue?vue&type=template&id=6c2191df&scoped=true"
import script from "./TableCustomerUseCoupon.vue?vue&type=script&lang=js"
export * from "./TableCustomerUseCoupon.vue?vue&type=script&lang=js"
import style0 from "./TableCustomerUseCoupon.vue?vue&type=style&index=0&id=6c2191df&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c2191df",
  null
  
)

export default component.exports